import http from "@/utils/http";


export const queryUmsUserPage = (query) =>{
	return http.get("/server/umsUser/list", query);
};

export const queryUmsUserSimpleList = (query) =>{
	return http.get(`/server/umsUser/queryUmsUserSimpleList`, query);
};
export const countUser = () =>{
	return http.get(`/server/umsUser/countUser`, );
};

